import * as _ from 'lodash-es'

export function getValueFromConfig(base: any, diff: any, path: string[]): string | boolean | null {
    const joinedPath = path.join('.')
    try {
        const baseValue = _.get(base, joinedPath)
        const diffValue = _.get(diff, joinedPath)

        if (diffValue || diffValue === 0) {
            return diffValue
        }
        if (baseValue) {
            return baseValue
        }
        return '-'
    } catch (error) {
        return '-'
    }
}
